<template>
  <div class="textarea-input">
    <label v-show="!!label"
           :class="{translateLabel}"
           @click="$refs['textarea'].focus()">
      {{ label }}
    </label>
    <textarea :value="value"
              ref="textarea"
              :class="!!size?`size-${size}`:''"
              v-bind="$attrs"
              v-on="listeners"
              :rows="!!value ? value.split('\n').length : 1">
    </textarea>
    <slot name="errors"></slot>
  </div>
</template>

<script>
export default {
  name: "BaseTextarea",
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: null
    },
    value: {},
    size: {
      type: String,
    }
  },
  data() {
    return {
      translateLabel: false
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        focusin: () => {
          if (Object.keys(this.$listeners).includes('focusin')) {
            this.$listeners['focusin']()
          }
          this.translateLabel = true
        },
        focusout: event => {
          if (Object.keys(this.$listeners).includes('focusout')) {
            this.$listeners['focusout']()
          }
          if (!event.target.value) {
            this.translateLabel = false
          }
        },
        input: event => this.$emit('input', event.target.value)
      }
    }
  },
  watch: {
    value: {
      handler(val) {
        this.translateLabel = !!val;
      }
    }
  },
  mounted() {
    if (!!this.value) {
      this.translateLabel = true
    }
  }
}
</script>

<style scoped lang="scss">
.textarea-input {
  @apply relative;
  textarea {
    @apply bg-block text-md border border-border rounded text-text-secondary px-5-6 py-4 outline-none w-full;
    min-height: 7rem;
    transition: all .2s;
    resize: none;
    color: #555;

    &:hover, &:focus {
      @apply border-border-hover;
    }

    &:read-only {
      opacity: .6;
    }

    &.size-sm {
      min-height: 4rem;
    }
  }

  label {
    @apply text-md text-text-ternary px-5-6 top-0 pt-4 transform absolute z-10 cursor-text;
    transition: all .2s;

    &:before {
      @apply bg-block;
      content: '';
      position: absolute;
      left: .5rem;
      top: 50%;
      width: calc(100% - 1rem);
      height: 9px;
      filter: blur(3px);
      z-index: -1;
    }

    &.translateLabel {
      @apply text-xs text-text-label pt-0 pr-6 top-0 -translate-y-1/2;
    }

    &:hover + textarea {
      @apply border-border-hover;
    }
  }

  .error {
    display: none;
  }

  &.--error {
    textarea {
      animation-name: shakeError;
      animation-fill-mode: forwards;
      animation-duration: 0.6s;
      animation-timing-function: ease-in-out;
      @apply border-red;
    }

    label {
      @apply text-xs text-red pt-0 pr-6 top-0 -translate-y-1/2 ;
    }


    .error {
      @apply block text-red text-sm absolute bottom-0 transform translate-y-full px-5-6;
    }
  }

  &.one-line textarea{
    min-height: unset;
  }
}

@keyframes shakeError {
  0% {
    transform: translateX(0px);
  }
  15% {
    transform: translateX(0.375rem);
  }
  30% {
    transform: translateX(-0.375rem);
  }
  45% {
    transform: translateX(0.375rem);
  }
  60% {
    transform: translateX(-0.375rem);
  }
  75% {
    transform: translateX(0.375rem);
  }
  90% {
    transform: translateX(-0.375rem);
  }
  100% {
    transform: translateX(0px);
  }
}
</style>
